/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PersonalRequisitionFieldsOneOf { 
    deleted?: boolean;
    deletedOn?: boolean;
    deletedBy?: boolean;
    createdOn?: boolean;
    modifiedOn?: boolean;
    createdBy?: boolean;
    modifiedBy?: boolean;
    id?: boolean;
    employeeReplaceName?: boolean;
    employeeReplaceId?: boolean;
    salary?: boolean;
    city?: boolean;
    creationReason?: boolean;
    code?: boolean;
    followsAuthorizationFlow?: boolean;
    requisitionTypeId?: boolean;
    jobPositionId?: boolean;
    currentStatusId?: boolean;
    immediateSuperiorId?: boolean;
    areaManagerId?: boolean;
    generalManagerId?: boolean;
    financeDirectorId?: boolean;
    createdByUser?: boolean;
    humanCapitalCompanyId?: boolean;
    companyId?: boolean;
    businessUnitId?: boolean;
}

